<template>
  <main class="main inside-page payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="page-inside-top">
          <div class="wrapper">
            <div class="title big">
              {{$t('Unfortunately, we were unable to process your payment. Please try again later')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'PaymentFaliPage',
  components: {
  },
  props: [],
  data: function() {
    return {
      
    }
  },
  methods: {
   
  }
}
</script>